import { LanguageType } from "~/types/language/language.types";

export const formatSimpleDate = (
  date: string | Date,
  language: LanguageType = "En"
) =>
  new Date(date).toLocaleDateString(language === "En" ? "en-EN" : "fr-FR", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  });

export const formatDate = (date: string, language: LanguageType = "En") =>
  new Date(date).toLocaleDateString(language === "En" ? "en-EN" : "fr-FR", {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
  });

export const formatTime = (date: string) =>
  new Date(date).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
